var usedcars = (function() {
	"use strict";

	return {
		carousel: {
			init: function() {
				$('button.carouselAll', '#usedcars').on('click', function(e) {
					$('#cars-element input[type=checkbox]').each(function() {
						$(this).attr('checked', (this.checked) ? '' : 'checked');
					});
					e.preventDefault();
					return false;
				});
			}
		}
	}
})();